<template>
  <v-dialog :model-value="modelValue" @update:modelValue="$emit('update:modelValue', $event)" width="500px">
    <v-card>
      <v-card-title>Créer un stock</v-card-title>
      <v-card-content>
        <v-text-field v-model="stockName"></v-text-field>
      </v-card-content>
      <v-card-actions class="justify-space-between">
        <v-btn color="primary" @click="closeDialog">Annuler</v-btn>
        <div>
          <v-btn color="primary" @click.prevent="saveChanges">Save</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { defineProps, defineEmits, ref} from 'vue';

const stockName = ref('');

const props = defineProps({
  modelValue: Boolean,
});

const emit = defineEmits(['update:modelValue', 'close', 'save']);

const saveChanges = async () => {
  emit('save', stockName.value);
};

const closeDialog = () => {
  emit('close');
};

</script>